/*
 * @Descripttion: 
 * @version: 有奇怪的bug 有时候会触发不了异步加载
 * @Author: TangXihao
 * @Date: 2021-05-12 16:48:44
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-07-20 10:10:27
 */
import React, { useState } from 'react';
import CustomModal from '../../components/CustomModal';
import closeimg from './img/icon-close.png'
import TextArea from 'antd/lib/input/TextArea';
import { Button, Input, message, Tree } from 'antd';
import { getDiskCatalogue, saveFolder } from './service/action';
import {connect} from "react-redux";


class Move2Modal extends React.Component {
    state = {
        treeData: [],
        loadedKeys: [],
        expandedKeys: [],
        selectedKeys: [],
    }
    async componentDidMount() {
        // let table = await getDiskCatalogue(mydisk.rootId)      
        console.log(this.props, this.state)
    }
    show = async () => {
        this.main.show()
        let treeData = [{
            key: this.props.mydisk.rootId,
            title: '我的网盘'
        }]

        let table = await this.getListData(this.props.mydisk.rootId)
        treeData[0].children = table
        console.log(treeData)
        setTimeout(() =>//能够降低bug概率
            this.setState({ treeData })
            , 100
        )
    }
    getListData = async (id) => {
        let treeData = []
        // console.log('检查用户token:',this.props.user);
        let table = await getDiskCatalogue(id,1,this.props.user.token)
        // console.log(table)
        table.forEach(async (element) => {
            if (element.type === 0 && element.id !== this.state.file.id) {
                // let children = await getDiskCatalogue(element.id)
                // console.log(children)
                treeData.push({
                    key: element.id,
                    title: element.name,
                    // children: [],
                    isLeaf: false,
                })
            }
        })
        console.log(treeData)
        return treeData
    }
    loadNode = async ({ key, children }) => {

        console.log('加载节点' + key, children)
        // if (!children) {
        //     return;
        // }

        let { loadedKeys, treeData } = this.state
        loadedKeys.push(key)
        this.setState({ loadedKeys })
        children = await this.getListData(key)

        let a = updateTreeData(treeData, key, children)
        console.log(a)
        this.setState({ treeData: a })
    }
    findNode = (children, id) => {
        // return new Promise((resolve, reject) => {
        if (!children) {
            // resolve(null)
            return null
        }
        let res
        children.forEach((ele) => {
            // console.log('ele.key:' + ele.key + 'id:' + ele.key)
            if (ele.key === id) {
                // resolve(ele)
                console.log('返回' + ele)
                res = ele
                return
            }
            let nodecc = this.findNode(ele.children, id)
            if (nodecc) {
                res = nodecc
                return
            }
        })
        // })
        // console.log('222')
        return res
    }
    close = () => {
        this.main.close()
        this.setState({ treeData: [], loadedKeys: [], selected: null })
    }
    confirm = async () => {
        let { file, selected } = this.state

        if (!selected) {
            message.warning("必须选择一个文件夹!")
            return
        }

        file.parentId = selected
        await saveFolder(file)
        this.setState({ treeData: [], loadedKeys: [], selected: null, selectedKeys: [] })
        this.close()
        this.props.reloadTable()
    }
    onSelect = (selectedKeys, info) => {
        console.log('selected', selectedKeys, info);
        this.setState({ selected: selectedKeys[0], selectedKeys: selectedKeys })
    }
    render() {
        return (<CustomModal ref={ref => this.main = ref}>
            <div className='clouddisk-move2-modal'>
                <div className={'clouddisk-move2-modal-title modal-dragable'} >
                    {'移动到'}
                    <img src={closeimg} alt="关闭" className={'clouddisk-publish-modal-closeimg'} onClick={() => this.close()}></img>
                </div>
                <Tree className='clouddisk-move2-modal-tree custom-scroll-panel-gray'
                    treeData={this.state.treeData}
                    // showLine={{ showLeafIcon: false }}
                    // expandedKeys={this.state.expandedKeys}
                    onSelect={this.onSelect}
                    loadData={this.loadNode}
                    loadedKeys={this.state.loadedKeys}
                    selectedKeys={this.state.selectedKeys}
                > </Tree>
                <div className='clouddisk-move2-modal-bottom'>
                    <Button className='clouddisk-move2-modal-cancel-btn' onClick={this.close}>取消</Button>
                    <Button className='clouddisk-move2-modal-confirm-btn' onClick={this.confirm}>确认</Button>
                </div>
            </div>
        </CustomModal>)
    }
}

function updateTreeData(list, key, children) {
    return list.map((node) => {
        if (node.key === key) {
            console.log('当前节点id符合')
            return { ...node, children };
        }
        if (node.children) {
            console.log('当前节点子目录符合')
            return { ...node, children: updateTreeData(node.children, key, children) };
        }

        return node;
    });
}

// export default Move2Modal
const mapState = (state) => ({ //返回值  对应的是  组件的props
    loginObj: state.userReducer.get('loginObj').toJS(),
    user: state.userReducer.get('user').toJS()
})
/**
 * 用来建立 UI 组件的参数到store.dispatch方法的映射。它定义了哪些用户的操作应该当作 Action，传给 Store。它可以是一个函数，也可以是一个对象。
 * @param {*} dispatch
 * @param {*} ownProps 容器组件的props对象
 */
const mapDispatch = (dispatch, ownProps) => ({})

export default connect(mapState, mapDispatch)(Move2Modal);
